import { useEffect, useState } from 'react'

export function App() {
  const [hasLogo, setHasLogo] = useState<boolean>(false)
  const [showSubtitle, setShowSubtitle] = useState<boolean>(false)
  const [showBlackText, setShowBlackText] = useState<boolean>(false)
  const [fadeOut, setFadeOut] = useState<boolean>(false)
  const [showLogo, setShowLogo] = useState<boolean>(false)

  useEffect(() => {
    fetch('/logo.svg', { method: 'HEAD' })
      .then(res => setHasLogo(res.ok))
      .catch(() => setHasLogo(false))
  }, [])

  useEffect(() => {
    // 0s: "coming soon" fades in as whole text over 2 seconds
    const subtitleTimer = setTimeout(() => {
      setShowSubtitle(true)
    }, 0)
    
    // 2s: Start fade out (takes 2 seconds)
    const hideWhiteTextTimer = setTimeout(() => {
      setFadeOut(true) // Start fade out animation
    }, 2000)
    
    // 2s: Start 3-second background fade from black to white
    const lightTimer = setTimeout(() => {
      document.documentElement.classList.add('light-on')
      document.body.classList.add('light-on')
    }, 2000)
    
    // 4s: Hide the text after fade out completes
    const hideTextTimer = setTimeout(() => {
      setShowSubtitle(false) // Hide the text after fade out
      setFadeOut(false) // Reset fade out state
    }, 4000) // 2s fade in + 2s fade out

    // 5s: Logo fades in
    const logoTimer = setTimeout(() => {
      setShowLogo(true)
    }, 5000)
    
    // 7s: Black text fades in character by character
    const blackTextTimer = setTimeout(() => {
      setShowBlackText(true)
      setShowSubtitle(true) // Show text again for black animation
    }, 7000)

    return () => {
      clearTimeout(subtitleTimer)
      clearTimeout(hideWhiteTextTimer)
      clearTimeout(hideTextTimer)
      clearTimeout(lightTimer)
      clearTimeout(logoTimer)
      clearTimeout(blackTextTimer)
    }
  }, [])

  const text = "coming soon"
  const characters = text.split("")

  return (
    <div className="page">
      <div className="grain" />
      <div className="center">
        {hasLogo && showLogo ? (
          <img className="logo" src="/logo.svg" alt="JÉGAIÉ" />
        ) : null}
        <p className={`subtitle ${showSubtitle ? 'visible' : ''} ${fadeOut ? 'fade-out' : ''} ${showBlackText ? 'black-text' : ''}`}>
          {characters.map((char, index) => (
            <span key={index} className="char" style={{ animationDelay: `${index * 0.1}s` }}>
              {char === " " ? "\u00A0" : char}
            </span>
          ))}
        </p>
      </div>
    </div>
  )
}
